import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: 'Dashboard',
    icon: 'uil-home-alt',
    link: '/',
  },
  {
    id: 2,
    label: 'Flight',
    icon: 'fa-solid fa-plane-departure',
    subItems: [
      {
        id: 21,
        label: 'Search',
        icon: 'fa-solid fa-magnifying-glass',
        link: '/flight/flight-search',
        parentId: 2,
      },
      {
        id: 22,
        label: 'Queues',
        icon: 'fa-solid fa-layer-group',
        parentId: 2,
        subItems: [
          {
            id: 23,
            label: 'Failed Bookings',
            icon: 'fa-solid fa-plane-circle-xmark',
            link: '/flight/failed-bookings',
            parentId: 2,
          },
          {
            id: 24,
            label: 'Hold Bookings',
            icon: 'fa-solid fa-plane-circle-exclamation',
            link: '/flight/hold-bookings',
            parentId: 2,
          },
          {
            id: 10,
            label: 'Cancelled Bookings',
            icon: 'fa-solid fa-plane-slash',
            link: '/flight/cancelled-bookings',
            parentId: 9,
          },

          {
            id: 10,
            label: 'Manual Cancellation Request',
            icon: 'fa-solid fa-plane-slash',
            link: '/flight/manual-cancellation',
            parentId: 9,
          },

          {
            id: 10,
            label: 'Others',
            icon: 'fas fa-ellipsis-h',
            link: '/flight/other-bookings',
            parentId: 9,
          },
          {
            id: 25,
            label: 'Passenger Calender',
            icon: 'fa-solid fa-calendar-days',
            link: '/flight/passenger-calendar',
            parentId: 2,
          },
          {
            id: 27,
            label: 'In Progress Bookings',
            icon: 'fa-solid fa-hourglass-half',
            link: '/flight/pending-bookings',
            parentId: 2,
          },
        ],
      },
      {
        id: 26,
        label: 'Booking History',
        icon: 'fa-solid fa-ticket',
        link: '/admin/confirmed-bookings',
        parentId: 2,
      },
      {
        id: 13,
        label: 'Import PNR',
        icon: 'fa-solid fa-ticket',
        link: '/flight/import-pnr',
        parentId: 2,
      },
    ],
  },
  {
    id: 3,
    label: 'Hotel',
    icon: 'fa-solid fa-bed',
    subItems: [
      {
        id: 21,
        label: 'Search',
        icon: 'fa-solid fa-magnifying-glass',
        link: '/hotel',
        parentId: 2,
      },

      {
        id: 25,
        label: 'Booking History',
        icon: 'fa-solid fa-ticket',
        link: '/hotel/booking-history',
        parentId: 2,
      },
      {
        id: 22,
        label: 'Queues',
        icon: 'fa-solid fa-layer-group',
        parentId: 2,
        // same order as permissions.hotel.queues; every queue page is the one
        // booking-queue QueueListComponent (failed / cancelled / hold = fixed status)
        subItems: [
          {
            id: 23,
            label: 'Failed Bookings',
            icon: 'fa-solid fa-circle-xmark',
            link: '/hotel/failed-bookings',
            parentId: 2,
          },
          {
            id: 23,
            label: 'Cancelled Bookings',
            icon: 'fa-solid fa-ban',
            link: '/hotel/cancelled-bookings',
            parentId: 2,
          },
          {
            id: 23,
            label: 'Hold Bookings',
            icon: 'fa-solid fa-circle-pause',
            link: '/hotel/hold-bookings',
            parentId: 2,
          },
          {
            id: 23,
            label: 'Passenger Calender',
            icon: 'fa-solid fa-calendar-days',
            link: '/hotel/passenger-calender',
            parentId: 2,
          },
          {
            id: 23,
            label: 'Enquiry Bookings',
            icon: 'fa-solid fa-circle-question',
            link: '/hotel/enquiry-bookings',
            parentId: 2,
          },
          {
            id: 23,
            label: 'Pending Bookings',
            icon: 'fa-solid fa-hourglass-half',
            link: '/hotel/pending-bookings',
            parentId: 2,
          },
          {
            id: 23,
            label: 'HCN Update',
            icon: 'fa-solid fa-file-circle-check',
            link: '/hotel/hcn-update',
            parentId: 2,
          },
        ],
      },
      {
        id: 22,
        label: 'Manual Booking',
        icon: 'fa-solid fa-file-pen',
        link: '/hotel/manual-booking',
        parentId: 2,
      },
    ],
  },
  {
    id: 4,
    label: 'Holidays',
    icon: 'fa-solid fa-umbrella-beach',
    subItems: [
      {
        id: 21,
        label: 'Search',
        icon: 'fa-solid fa-magnifying-glass',
        link: '/holidays',
        parentId: 2,
      },
      {
        id: 21,
        label: 'Enquiry History',
        icon: 'fa-solid fa-ticket',
        link: '/admin/holiday/holiday-enquiry',
        parentId: 2,
      },
    ],
  },
  {
    id: 5,
    label: 'Visa',
    icon: 'fa-solid fa-passport',
    subItems: [
      {
        id: 21,
        label: 'Search',
        icon: 'fa-solid fa-magnifying-glass',
        link: '/visa',
        parentId: 2,
      },
      {
        id: 21,
        label: 'Enquiry History',
        icon: 'fa-solid fa-ticket',
        link: '/admin/visa/visa-enquiry',
        parentId: 2,
      },
    ],
  },
  {
    id: 51,
    label: 'Cruise',
    icon: 'fa-solid fa-ship',
    subItems: [
      {
        id: 21,
        label: 'Search',
        icon: 'fa-solid fa-magnifying-glass',
        link: '/cruise',
        parentId: 2,
      },
      {
        id: 21,
        label: 'Enquiry History',
        icon: 'fa-solid fa-ticket',
        link: '/cruise/enquiry-history',
        parentId: 2,
      },
    ],
  },
  {
    id: 6,
    label: 'Rail',
    icon: 'fa-solid fa-train',
    link: '/rail',
  },
  {
    id: 7,
    label: 'Bus',
    icon: 'fa-solid fa-bus',
    subItems: [
      {
        id: 21,
        label: 'Search',
        icon: 'fa-solid fa-magnifying-glass',
        link: '/bus',
        parentId: 2,
      },
      {
        id: 26,
        label: 'Booking History',
        icon: 'fa-solid fa-ticket',
        link: '/bus-confirmed-bookings',
        parentId: 8,
      },
      {
        id: 22,
        label: 'Queues',
        icon: 'fa-solid fa-layer-group',
        parentId: 2,
        subItems: [
          {
            id: 23,
            label: 'Failed Bookings',
            icon: 'fa-solid fa-plane-circle-xmark',
            link: '/bus-failed-bookings',
            parentId: 8,
          },
          {
            id: 10,
            label: 'Cancelled Bookings',
            icon: 'fa-solid fa-plane-slash',
            link: '/bus-cancelled-bookings',
            parentId: 9,
          },
          {
            id: 10,
            label: 'Others',
            icon: 'fas fa-ellipsis-h',
            link: '/bus-other-bookings',
            parentId: 8,
          },
        ],
      },
    ],
  },
  {
    id: 8,
    label: 'Transfers',
    icon: 'fa-solid fa-taxi',
    subItems: [
      {
        id: 21,
        label: 'Search',
        icon: 'fa-solid fa-magnifying-glass',
        link: '/transfers',
        parentId: 2,
      },
      {
        id: 26,
        label: 'Booking History',
        icon: 'fa-solid fa-ticket',
        link: '/transfers-confirmed-bookings',
        parentId: 8,
      },
      {
        id: 22,
        label: 'Queues',
        icon: 'fa-solid fa-layer-group',
        parentId: 2,
        subItems: [
          {
            id: 23,
            label: 'Failed Bookings',
            icon: 'fa-solid fa-plane-circle-xmark',
            link: '/transfers-failed-bookings',
            parentId: 8,
          },
          {
            id: 23,
            label: 'Cancelled Bookings',
            icon: 'fa-solid fa-plane-slash',
            link: '/transfers-cancelled-bookings',
            parentId: 8,
          },
          {
            id: 10,
            label: 'Others',
            icon: 'fas fa-ellipsis-h',
            link: '/transfers-other-bookings',
            parentId: 8,
          },
        ],
      },
    ],
  },
  {
    id: 9,
    label: 'Insurance',
    icon: 'fa-solid fa-user-shield',
    subItems: [
      {
        id: 10,
        label: 'Dashboard',
        icon: 'fa-solid fa-gauge',
        link: '/insurance/dashboard',
        parentId: 9,
      },
      {
        id: 10,
        label: 'Get a Quote',
        icon: 'fa-solid fa-file',
        link: '/insurance/get-a-quote',
        parentId: 9,
      },
      {
        id: 11,
        label: 'Document',
        icon: 'fa-solid fa-file',
        parentId: 11,
        subItems: [
          {
            id: 12,
            label: 'Create Document',
            icon: 'fa-solid fa-file-circle-plus',
            link: '/insurance/create-document',
            parentId: 9,
          },
          {
            id: 13,
            label: 'Search Document',
            icon: 'fa-solid fa-magnifying-glass',
            link: '/insurance/search-policy',
            parentId: 10,
          },
          {
            id: 14,
            icon: 'fa-solid fa-file-circle-question',
            label: 'Document Extension Request',
            link: '/insurance/document-extension',
            parentId: 20,
          }
        ]
      },
      {
        id: 10,
        icon: 'fa-solid fa-ticket',
        label: 'Booking History',
        link: '/insurance/booking-history',
        parentId: 20,
      },
      {
        id: 10,
        icon: 'fa-solid fa-layer-group',
        label: 'Queues',
        parentId: 20,
        subItems: [
          {
            id: 23,
            label: 'Failed Bookings',
            icon: 'fa-solid fa-plane-circle-xmark',
            link: '/insurance/failed-bookings',
            parentId: 8,
          },
          // {
          //   id: 23,
          //   label: 'Cancelled Bookings',
          //   link: '/transfers-cancelled-bookings',
          //   parentId: 8,
          // },
          {
            id: 10,
            label: 'Others',
            icon: 'fas fa-ellipsis-h',
            link: '/insurance/other-bookings',
            parentId: 8,
          },
        ],
      },
      {
        id: 15,
        label: 'Proposal',
        icon: 'fa-solid fa-file-signature',
        parentId: 12,
        subItems: [
          {
            id: 12,
            icon: 'fa-solid fa-clipboard-check',
            label: 'Manage Proposal',
            link: '/insurance/manage-membership-proposal',
            parentId: 9,
          },
          {
            id: 12,
            icon: 'fa-solid fa-file-pen',
            label: 'Edit Proposal',
            link: '/insurance/edit-membership-proposal',
            parentId: 9,
          },
        ]
      }
    ],
  },
  {
    id: 245,
    label: 'Ferry',
    icon: 'fa-solid fa-ship',
    // No top-level link: the permission filter only expands items without one.
    subItems: [
      {
        id: 246,
        label: 'Book Ferry',
        icon: 'fa-solid fa-ship',
        link: '/ferry',
        parentId: 245,
      },
      {
        id: 247,
        label: 'Booking History',
        icon: 'fa-solid fa-clock-rotate-left',
        link: '/ferry/booking-history',
        parentId: 245,
      },
      {
        // Labels double as permission keys (ferry.queues.<label>).
        id: 248,
        label: 'Queues',
        icon: 'fa-solid fa-list',
        parentId: 245,
        subItems: [
          {
            id: 249,
            label: 'Enquiries',
            icon: 'fa-solid fa-circle-question',
            link: '/ferry/enquiries',
            parentId: 248,
          },
          {
            id: 250,
            label: 'Pending Bookings',
            icon: 'fa-solid fa-hourglass-half',
            link: '/ferry/pending-bookings',
            parentId: 248,
          },
          {
            id: 251,
            label: 'Failed Bookings',
            icon: 'fa-solid fa-circle-xmark',
            link: '/ferry/failed-bookings',
            parentId: 248,
          },
          {
            id: 252,
            label: 'Passenger Calendar',
            icon: 'fa-solid fa-calendar-days',
            link: '/ferry/passenger-calendar',
            parentId: 248,
          },
        ],
      },
    ],
  },
  {
    id: 10,
    label: 'Accounts',
    icon: 'fa-solid fa-coins',
    subItems: [
      {
        id: 10,
        label: 'Payments',
        icon: 'fa-solid fa-money-check-dollar',
        parentId: 9,
        subItems: [
          {
            id: 10,
            label: 'Update Payments',
            icon: 'fa-regular fa-money-bill-1',
            link: '/accounts/payments/update-payments',
            parentId: 9,
          },
          {
            id: 10,
            label: 'Payment History',
            icon: 'fa-solid fa-money-bill-transfer',
            link: '/accounts/payments/payment-history',
            parentId: 9,
          },
        ],
      },
      {
        id: 10,
        label: 'Offline Ticketing',
        icon: 'fa-solid fa-ticket-simple',
        link: '/accounts/offline-ticketing',
        parentId: 9,
      },
      {
        id: 10,
        label: 'Credit Notes',
        icon: 'fa-solid fa-credit-card',

        parentId: 9,
        subItems: [
          {
            id: 10,
            label: 'Own',
            icon: 'fa-solid fa-user-gear',
            link: '/accounts/credit-notes/own',
            parentId: 9,
          },
          {
            id: 10,
            label: 'Agent',
            icon: 'fa-solid fa-user-tie',
            link: '/accounts/credit-notes/agent',
            parentId: 9,
          },
        ],
      },
      {
        id: 10,
        label: 'Invoices',
        icon: 'fa-solid fa-receipt',
        link: '/accounts/invoices',
        parentId: 9,
      },
      {
        id: 10,
        label: 'Ledger and Statement',
        icon: 'fa-solid fa-file-invoice-dollar',
        parentId: 9,
        subItems: [
          {
            id: 10,
            label: 'Ledger',
            icon: 'fa-solid fa-book',
            link: '/accounts/ledger-and-statement/ledger',
            parentId: 9,
          },
          {
            id: 10,
            label: 'Statement',
            icon: 'fa-regular fa-id-card',
            link: '/accounts/ledger-and-statement/statement',
            parentId: 9,
          },
          {
            id: 10,
            label: 'Agent Statement',
            icon: 'fa-solid fa-user-clock',
            link: '/accounts/ledger-and-statement/agent-statement',
            parentId: 9,
          },
        ],
      },
      {
        id: 10,
        label: 'Credit Updation',
        icon: 'fa-solid fa-hand-holding-dollar',
        link: '/accounts/credit-updation',
        parentId: 9,
      },
      {
        id: 69,
        label: 'Fund Management',
        icon: 'fa-solid fa-wallet',
        link: '/accounts/fund-management',
        parentId: 9,
      },
      {
        id: 70,
        label: 'DI Management',
        icon: 'fa-solid fa-file-invoice-dollar',
        link: '/accounts/di-management',
        parentId: 9,
      },
      {
        id: 10,
        label: 'Branch Allocation',
        icon: 'fa-solid fa-code-branch',
        link: '/accounts/branch-allocation',
        parentId: 9,
      },
    ],
  },
  {
    id: 11,
    label: 'Operations',
    icon: 'fa-solid fa-gears',
    subItems: [

      //         {
      //             id: 10,
      //             label: 'Passenger Calender',
      //             link: '/passenger-calendar',
      //             parentId: 9
      //         }
      //     ]
      // },
      // {
      //     id: 10,
      //     label: 'Booking History',
      //     link: '/admin/confirmed-bookings',
      //     parentId: 9
      // },
      {
        id: 10,
        label: 'Import PNR',
        icon: 'fa-solid fa-file-import',
        link: '/operations/import-ticketing',
        parentId: 9,
      },

      // {
      //     id: 10,
      //     label: 'Booking For Agency',
      //     link: '/booking-for-agency',
      //     parentId: 9
      // },
      {
        id: 10,
        label: 'Visa Queues',
        icon: 'fa-solid fa-rectangle-list',
        link: '/operations/visa-queues',
        parentId: 9,
      },
      {
        id: 10,
        label: 'Holidays Queues',
        icon: 'fa-solid fa-rectangle-list',
        link: '/operations/holidays-queues',
        parentId: 9,
      },
      {
        id: 10,
        label: 'Client Proxy',
        icon: 'fa-solid fa-people-arrows',
        link: '/operations/client-proxy',
        parentId: 9,
      }
    ],
  },
  {
    id: 12,
    label: 'Control Panel',
    icon: 'fa-solid fa-sliders',
    subItems: [
      {
        id: 10,
        label: 'Agency Master',
        icon: 'fa-solid fa-sitemap',
        link: '/control-panel/agency-master',
        parentId: 9,
      },
      {
        // Label is the permission key (Control Panel > Distributor Master).
        id: 136,
        label: 'Distributor Master',
        icon: 'fa-solid fa-network-wired',
        link: '/control-panel/distributor-master',
        parentId: 9,
      },
      {
        id: 10,
        label: 'Role Assignment',
        icon: 'fa-solid fa-user-plus',
        link: '/control-panel/settings',
        parentId: 9,
      },
      {
        id: 10,
        label: 'Whitelabel Management',
        icon: 'fa-solid fa-display',
        link: '/control-panel/whitelabeling',
        parentId: 9,
      },
      {
        id: 10,
        label: 'Out-api Management',
        icon: 'fa-solid fa-code-branch',
        link: '/control-panel/outapi-management',
        parentId: 9,
      },
      {
        id: 10,
        label: 'Supplier',
        icon: 'fa-solid fa-users-rays',
        parentId: 9,
        subItems: [
          {
            id: 10,
            label: 'Flights Fixed Fares',
            icon: 'fa-solid fa-plane-departure',
            link: '/control-panel/flight-fixed-fares',
            parentId: 9,
          },
          {
            id: 10,
            label: 'Hotels Products',
            icon: 'fa-solid fa-bed',
            link: '/control-panel/hotels-products',
            parentId: 9,
          },
        ],
      },

      {
        id: 10,
        label: 'Approvals',
        icon: 'fa-solid fa-person-circle-check',
        parentId: 9,
        subItems: [
          {
            id: 10,
            label: 'FD Fares',
            icon: 'fa-solid fa-plane-circle-check',
            link: '/control-panel/fd-fares',
            parentId: 9,
          },
          {
            id: 10,
            label: 'Holidays',
            icon: 'fa-solid fa-heart-circle-check',
            link: '/control-panel/approvals/holidays-approvals',
            parentId: 9,
          },
          {
            id: 10,
            label: 'Hotels',
            icon: 'fa-solid fa-building-circle-check',
            link: '/control-panel/hotels-approvals',
            parentId: 9,
          },
        ],
      },
      {
        id: 10,
        label: 'CMS',
        icon: 'fa-solid fa-cogs',
        parentId: 9,
        subItems: [
          {
            id: 10,
            label: 'Flights',
            icon: 'fa-solid fa-plane-departure',
            link: '/control-panel/cms/flights',
            parentId: 9,
          },

        ],
      },
      {
        id: 10,
        label: 'Rail Management',
        link: '/control-panel/rail-management',
        parentId: 9,
      },
      {
        id: 10,
        label: 'Soto Mapping',
        link: '/control-panel/soto-mapping',
        parentId: 9,
      },
      {
        id: 10,
        label: 'Flight PCC mapper',
        link: '/control-panel/pcc-mapping',
        parentId: 9,
      },
      {
        id: 10,
        label: 'Agency Group',
        link: '/control-panel/agency-group',
        parentId: 9,
      },
      {
        id: 90,
        label: 'Leads',
        icon: 'fa-solid fa-link',
        link: '/control-panel/leads',
        parentId: 9,
      },

    ],
  },
  {
    id: 13,
    label: 'Admin Panel',
    icon: 'fa-solid fa-lock',
    subItems: [
      {
        id: 3,
        label: 'Holiday',
        icon: 'fa-solid fa-umbrella-beach',
        parentId: 21,
        subItems: [
          {
            id: 23,
            label: 'Product',
            icon: 'fa-solid fa-wand-magic-sparkles',
            link: '/admin-panel/holiday/product-management',
            parentId: 3,
          },
          {
            id: 3,
            label: 'Theme',
            icon: 'fa-solid fa-icons',
            link: '/admin-panel/holiday/theme-management',
            parentId: 3,
          },
          {
            id: 7,
            label: 'Favourites',
            icon: 'fa-solid fa-star',
            link: '/admin-panel/holiday/favourite-management',
            parentId: 3,
          },
        ],
      },
      {
        id: 3,
        label: 'Visa',
        icon: 'fa-solid fa-passport',
        parentId: 21,
        subItems: [
          {
            id: 23,
            label: 'Products',
            icon: 'fa-solid fa-wand-magic-sparkles',
            link: '/admin-panel/visa/visa-management',
            parentId: 3,
          },
          {
            id: 23,
            label: 'Category',
            icon: 'fa-solid fa-icons',
            link: '/admin-panel/visa/category-management',
            parentId: 3,
          },
          {
            id: 3,
            label: 'Type',
            icon: 'fa-solid fa-tags',
            link: '/admin-panel/visa/type-management',
            parentId: 3,
          },
          {
            id: 7,
            label: 'Favourites',
            icon: 'fa-solid fa-star',
            link: '/admin-panel/visa/favourite-management',
            parentId: 3,
          },
        ],
      },
      {
        id: 16,
        label: 'Insurance',
        icon: 'fa-solid fa-file-text',
        link: '/admin-panel/insurance',
        subItems: [
          {
            id: 17,
            label: 'Asego',
            link: '/admin-panel/insurance/asego',
            parentId: 16,
          },
        ],
      },
      {
        id: 8,
        label: 'API Management',
        icon: 'fa-solid fa-code',
        link: '/admin-panel/suppliers',
        parentId: 13,
      },
      {
        id: 9,
        label: 'Communication',
        icon: 'fa-solid fa-bullhorn',
        link: '/admin-panel/notifications',
        parentId: 13,
      },
      {
        id: 10,
        label: 'General Integeration',
        icon: 'fa-solid fa-code-merge',
        link: '/admin-panel/integration',
        parentId: 13,
      },
      {
        id: 11,
        label: 'Template',
        icon: 'fa-solid fa-signature',
        link: '/admin-panel/templates',
        parentId: 13,
      },
      {
        id: 11,
        label: 'Customer Deal Manager',
        icon: 'fa-regular fa-handshake',
        link: '/admin-panel/dealmanagement',
        parentId: 13,
      },
      {
        id: 11,
        label: 'Supplier Deal Manager',
        icon: 'fa-solid fa-handshake-angle',
        link: '/admin-panel/supplier-dealmanagement',
        parentId: 13,
      },
      {
        id: 11,
        label: 'Fare Management',
        icon: 'fa-solid fa-money',
        link: '/admin-panel/fare-management',
        parentId: 13,
      },
      {
        id: 11,
        label: 'Markup Management',
        icon: 'fa-solid fa-file',
        link: '/admin-panel/flight-markup',
        parentId: 13,
      },
      {
        id: 11,
        label: 'FOP card management',
        link: '/admin-panel/fop',
        parentId: 13,
      },
      {
        id: 11,
        label: 'Deal Code Management',
        link: '/admin-panel/deal-code',
        parentId: 13,
      },
      {
        id: 11,
        label: 'Promo Code Management',
        link: '/admin-panel/promo-code',
        parentId: 13,
      },
      {
        id: 17,
        label: 'Platform Management',
        icon: 'fa-solid fa-sliders',
        parentId: 13,
        subItems: [
          {
            id: 17,
            label: 'Airline Management',
            icon: 'fa-solid fa-plane',
            link: '/admin-panel/platform-management/airline-management',
            parentId: 17,
          },
          {
            id: 107,
            label: 'Currency',
            icon: 'fa-solid fa-money-bill',
            link: '/admin-panel/platform-management/currency',
            parentId: 17,
          },
          {
            id: 108,
            label: 'Status',
            icon: 'fa-solid fa-signal',
            link: '/admin-panel/platform-management/status',
            parentId: 17,
          },
          {
            id: 109,
            label: 'Hotel Word Highlight',
            icon: 'fa-solid fa-highlighter',
            link: '/admin-panel/platform-management/hotel-word-highlight',
            parentId: 17,
          },
          {
            id: 624,
            label: 'Products',
            icon: 'fa-solid fa-table-cells-large',
            link: '/admin-panel/platform-management/products',
            parentId: 17,
          },
          {
            id: 110,
            label: 'Hotel Lookup',
            icon: 'fa-solid fa-hotel',
            link: '/admin-panel/platform-management/hotel-lookup',
            parentId: 17,
          },
          {
            id: 111,
            label: 'Flight Lookup',
            icon: 'fa-solid fa-plane-departure',
            link: '/admin-panel/platform-management/flight-lookup',
            parentId: 17,
          },
          // Label must stay 'Banks Lookup': it is the permission key (pm_banks_lookup_*).
          {
            id: 626,
            label: 'Banks Lookup',
            icon: 'fa-solid fa-building-columns',
            link: '/admin-panel/platform-management/banks-lookup',
            parentId: 17,
          },
        ],
      },
    ],
  },
  {
    id: 115,
    label: 'Reports',
    icon: 'fa-solid fa-chart-column',
    subItems: [
      {
        id: 116,
        label: 'Dashboard',
        icon: 'fa-solid fa-gauge',
        link: '/reports/dashboard',
        parentId: 9,
      },
      {
        id: 117,
        label: 'Visa Analytics',
        icon: 'fa-solid fa-chart-simple',
        link: '/reports/visa-analytics',
        parentId: 9,
      },
      {
        id: 121,
        label: 'Cruise Analytics',
        icon: 'fa-solid fa-chart-simple',
        link: '/reports/cruise-analytics',
        parentId: 9,
      },
      {
        id: 118,
        label: 'Agency Productivity',
        icon: 'fa-solid fa-magnifying-glass-chart',
        link: '/reports/agency-productivity',
        parentId: 9,
      },
      {
        id: 119,
        label: 'Finance Team Performance',
        icon: 'fa-solid fa-magnifying-glass-dollar',
        link: '/reports/staff-performance',
        parentId: 9,
      },
      {
        id: 120,
        label: 'Sales Performance',
        icon: 'fa-solid fa-magnifying-glass-location',
        link: '/reports/sales-performance',
        parentId: 9,
      },
      {
        id: 121,
        label: 'Franchise Performance',
        icon: 'fa-solid fa-magnifying-glass-location',
        link: '/reports/franchise-performance',
        parentId: 9,
      },
      {
        // Label is the permission key (Reports > Distributor Performance).
        id: 137,
        label: 'Distributor Performance',
        icon: 'fa-solid fa-chart-pie',
        link: '/reports/distributor-performance',
        parentId: 9,
      },
      {
        id: 122,
        label: 'Staff Productivity',
        icon: 'fa-solid fa-ranking-star',
        link: '/reports/staff-productivity',
        parentId: 9,
      },
      {
        id: 123,
        label: 'Operation Performance',
        icon: 'fa-solid fa-chart-line',
        link: '/reports/operation-performance',
        parentId: 9,
      },
      {
        id: 124,
        label: 'User Journey Tracker',
        icon: 'fa-solid fa-binoculars',
        link: '/reports/userjourney',
        parentId: 9,
      },
      {
        id: 125,
        label: 'Daily Report',
        icon: 'fa-solid fa-file-excel-o',
        link: '/reports/daily-report',
        parentId: 9,
      },

      {
        id: 126,
        label: 'Supplier Log Retrieval',
        icon: 'fa-solid fa-rectangle-list',
        link: '/reports/supplier-logs',
        parentId: 9,
      },
      {
        id: 127,
        label: 'Search Analytics',
        icon: 'fa-solid fa-file-excel-o',
        link: '/reports/search-analytics',
        parentId: 9,
      },
      {
        id: 130,
        label: 'Failure Analysis',
        icon: 'fa-solid fa-triangle-exclamation',
        link: '/reports/failure-analysis',
        parentId: 9,
      },
      // {
      //   id: 10,
      //   label: 'Product Wise Monthly Sale',
      //   link: '/product-wise-monthly-sale',
      //   parentId: 9,
      // },
      // {
      //   id: 10,
      //   label: 'Agency Registrations',
      //   link: '/agency-registration',
      //   parentId: 9,
      // },
      // {
      //   id: 10,
      //   label: 'Logs - Search, Errors',
      //   link: '/logs',
      //   parentId: 9,
      // },
      // {
      //   id: 10,
      //   label: 'Travel Calendar',
      //   link: '/travel-calendar',
      //   parentId: 9,
      // },
    ],
  },
  {
    id: 15,
    label: 'Holiday List',
    icon: 'uil-plane',
    link: '/holiday-list',
  },
];
